import React from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Aim_To_Scale_Up.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";

const Aim_To_Scale_Up = () => {
  const data = [
    {
      name: "Manufacturing Automation",
      description:
        "Implementing automation to increase production capacity and maintain consistent quality.",
      image: "/assets/images/home/aim_to_scale_up/img1.png",
    },
    {
      name: "Modern Trade Growth",
      description:
        "Increasing our footprint in large retail chains like D-Mart, Vishal Mega Maart,and other supermarkets.",
      image: "/assets/images/home/aim_to_scale_up/img2.png",
    },
    {
      name: "Product Expansion",
      description:
        "Planned scale-up into wider healthy snacking and beverage portfolio, including amla candy, premium kokum syrup, bhadang, banana chips, and affordable protein bars.",
      image: "/assets/images/home/aim_to_scale_up/img3.png",
    },

    {
      name: "Increasing Presence in E-Com & Q-Com ",
      description:
        "Implementing automation to increase production capacity and maintain consistent quality.",
      image: "/assets/images/home/aim_to_scale_up/img4.png",
    },
    {
      name: "Distribution Network Expansion",
      description:
        "Partnering with more channel distributors to enhance product availability in General Trade stores.",
      image: "/assets/images/home/aim_to_scale_up/img5.png",
    },
  ];

  return (
    <section className="Aim_To_Scale_Up">
      <div className="container">
        <Heading_title title={"Aim To Scale Up"} />

        <div className="row">
          <Swiper
            spaceBetween={15}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              486: {
                slidesPerView: 1.5,
              },
              500: {
                slidesPerView: 1.8,
              },
              578: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2.5,
              },
              991: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
              },
              1400: {
                slidesPerView: 5,
              },
              1600: {
                slidesPerView: 5,
              },
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {data.map((val) => (
              <SwiperSlide key={val.id}>
                <div className="col-md-12 mt-3">
                  <div
                    className="icon-box"
                    data-aos="fade-left"
                    data-aos-delay="100"
                  >
                    <div className="image_holder text-center">
                      <img
                        rel="preload"
                        loading="lazy"
                        src={process.env.PUBLIC_URL + val.image}
                        className="inner_img"
                      />
                    </div>
                    <p className="title_text">{val.name}</p>
                    <div className="description">{val?.description}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Aim_To_Scale_Up;
